import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`
export const SubMenu = styled.div`
  display: flex;
  margin-left: 15px;
`
